import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate(['SAVE_STATE']);
export const CHAR_LIMIT = 1500;
